import { Dropdown } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { useDispatch } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Api } from '../../../config/api/axiosInterceptors';
import { logout } from '../../../redux/authUser/actions';
import avatar from '../../../static/img/balken/avatar_BALKEN.png';

function AuthInfo() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { path } = useRouteMatch();
  const page = `${path}/perfil`;

  const SignOut = async () => {
    try {
      await Api.post('/logout');
      history.push('/login');
      dispatch(logout());
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const items = [
    {
      key: 'profile',
      label: 'Mi perfil',
      icon: <FeatherIcon icon="user" size={14} />,
      onClick: () => history.push(page),
      className: 'avatar-dropdown-item',
    },

    {
      key: 'logout',
      label: 'Cerrar sesión',
      icon: <FeatherIcon icon="log-out" size={14} />,
      onClick: SignOut,
      className: 'avatar-dropdown-item',
    },
  ];

  return (
    <Dropdown menu={{ items, className: 'avatar-dropdown' }} trigger={['click']}>
      <img src={avatar} alt="" className="avatar-logo" />
    </Dropdown>
  );
}

export default AuthInfo;
